import { useEffect, useState } from 'react';

/**
 * useState that also keeps its value in sessionStorage under `key`, so it survives leaving the page
 * and coming back (e.g. list → order details → Back). Per browser tab; gone when the tab is closed.
 * `revive` turns the stored JSON back into the right shape (e.g. date strings → Date).
 */
export default function useSessionState(key, initialValue, revive = (v) => v) {
    const [value, setValue] = useState(() => {
        try {
            const stored = sessionStorage.getItem(key);
            return stored === null ? initialValue : revive(JSON.parse(stored));
        } catch (e) {
            return initialValue;
        }
    });

    useEffect(() => {
        try {
            sessionStorage.setItem(key, JSON.stringify(value));
        } catch (e) {
            // Storage blocked or full: the value still works for this visit, it just isn't kept.
        }
    }, [key, value]);

    return [value, setValue];
}
